import React from "react"
import Banner from "../containers/banner"
import Service from "../containers/service"
import Project from "../containers/project"
import Portfolio from '../containers/portfolio'
import Testimonial from '../containers/testimonial'
import Layout from "../containers/layout";

const IndexPage = () => {
    return (
        <Layout>
            <Banner home ChangeClass={'demo1'} title="NGT Transformation Services" body={
                <div>
                    <h3>NGTTS: What we do?</h3>
                    We are business transformation specialists. <br/>We co-build the strategy and support active execution to deliver our promise on ground. <br/>Our unique proposition is that we walk the talk.
                </div>
            }/>
            <Service home />
            <Project />
            <Portfolio />
            <Testimonial />
        </Layout>
    )
}

export default IndexPage
